/**
 * Created by jonas on 2020-10-03.
 */
import {ArrayUtils} from "./ArrayUtils";


export interface StateMatrixCoordinate{
    column:number;
    row:number;
}
export class StateMatrix<T> {
    get matrix():T[][] {
        return this._matrix;
    }

    set matrix(value:T[][]) {
        this._matrix = value;
    }

    private _matrix:T[][];
    public readonly columns:number;
    public readonly rows:number;

    constructor(initMatrix?:T[][]) {
        this._matrix = initMatrix ? ArrayUtils.cloneMatrix(initMatrix) : [];
    }

    public initWithValue(columns:number, rows:number, initValue:T){
        this._matrix = [];
        for (let i:number = 0; i < columns; i++){
            this._matrix.push([]);
            for (let j:number = 0; j < rows; j++){
                this._matrix[i].push(initValue);
            }
        }
    }

    public getAllCoordinateForValue(value:T):StateMatrixCoordinate[] {
        const result:StateMatrixCoordinate[] = []
        for (let i:number = 0; i < this._matrix.length; i++){
            for (let j:number = 0; j < this._matrix[i].length; j++){
                if (this._matrix[i][j] === value){
                    result.push({column:i,row:j});
                }

            }
        }
        return result;
    }

    /**
     *
     * @param callback (value:T,column?:number,row?:number)=>boolean. Function to execute on each element.
     */
    public getAllCoordinatesWhere(callback:(value:T,column?:number,row?:number)=>boolean):StateMatrixCoordinate[] {
        const result:StateMatrixCoordinate[] = []
        for (let i:number = 0; i < this._matrix.length; i++){
            for (let j:number = 0; j < this._matrix[i].length; j++){
                if (callback(this._matrix[i][j], i, j)){
                    result.push({column:i,row:j});
                }

            }
        }
        return result;
    }


    public getCoordinatedForValueInColumn(column:number, value:T):StateMatrixCoordinate[] {
        const result = [];
        for (let j:number = 0; j < this._matrix[column].length; j++){
            if (this._matrix[column][j] === value){
                result.push({column:column,row:j});
            }
        }
        return result;
    }

    public setValueForCoordinates(coordinates:StateMatrixCoordinate[], value:T){
        for (let coord of coordinates){
            this.matrix[coord.column][coord.row] = value;
        }
    }

    public setValueForColumn(column:number, value:T){
        for (let i:number = 0; i < this.matrix[column].length;i++){
            this.matrix[column][i] = value;
        }
    }


    public toString():string {
        let str = "";

        for (let i:number = 0; i < this._matrix.length; i++) {
            let row:string = `${i}:(${this._matrix[i].length}) [`;
            for (let j:number = 0; j < this._matrix[i].length; j++) {
                row += "" + this._matrix[i][j];

                if (j != this._matrix[i].length-1){
                    row += ","
                }
            }

            row += "]";
            str += row + "\n";
        }
        return str;
    }


    /**
     * returns array length = num of columns with true if value is present in that column, flas if not.
     * @param value
     */
    public isValueInColumns(value:T) {
        const result:boolean[] = [];
        for (let i:number = 0; i < this._matrix.length; i++){
            result.push(this.isValueInColumn(i, value));
        }
        return result;
    }

    public isValueInColumn(column:number, value:T):boolean{
        for (let i:number = 0; i < this._matrix[column].length; i++){
            if (this._matrix[column][i] === value){
                return true
            }
        }

        return false;
    }
}